import _ from 'lodash';
import window from 'global/window';

const {
  REACT_APP_POS_API_URI,
  REACT_APP_API_URI: mainApi,
  REACT_APP_ADMIN_URI: admin,
  REACT_APP_CORE_URI
} = process.env;

const POSApi = REACT_APP_POS_API_URI || getApiUriFromSubdomain();
const COREApi = REACT_APP_CORE_URI;

function getApiUriFromSubdomain() {
  const hostname = _.get(window, ['location', 'hostname'], '');
  const subdomain = _.get(hostname.match(/(^[\d\w-_]+)/), '[0]');

  return _.replace(
    mainApi,
    /(^(https?:\/\/|\/\/))/,
    (match, protocol) => `${protocol}${subdomain}.`
  );
}

export default { mainApi, POSApi, admin, COREApi };



// WEBPACK FOOTER //
// ../pos-master/packages/pos-helper/src/host.js